/* eslint-disable */
const introVSIconBlocks = {
    init: function () {
        //console.log('introBlocks');
        let introBlocks = document.querySelectorAll('.section--intro');
        if (!introBlocks || !introBlocks.length) return;
        //console.log('introBlocks 2');

        introBlocks.forEach((introBlock) => {
            //console.log('introBlocks 3');
            const nextBlock = introBlock.nextElementSibling;
            if (nextBlock && nextBlock.classList.contains('section--icon')) {
                //console.log('introBlocks 4');
                nextBlock.classList.add('section--icon--intro-prev');
                introBlock.classList.add('section--intro--icon-next');
            }
        });
    },
}

export default introVSIconBlocks;